import Link from "next/link";

// MUI
import Box from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Container from "@mui/system/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// import Divider from '@mui/material/Divider';
import Carousel from 'react-material-ui-carousel'
// const Carousel = dynamic(() => import("react-material-ui-carousel"));

// Styles
const title = {
  // typography: { 
  //   sm: 'h2', 
  //   xs: 'h6' 
  // } 
  fontSize: "calc(.7em + 1vw)",
  paddingBottom: "1vh",
  fontWeight: "bold"
}

const brand = {
  paddingBottom: "2vh",
  fontSize: "calc(.7em + 1vw)"
}

const priceCss = {
  color: "green",
  fontSize: "1.5rem"
}

const scrappedTextTitle = {
  fontSize: "1.25rem",
  marginLeft: "10px",
  whiteSpace: "break-spaces",
  fontWeight: "bold"
};

const scrappedTextBody = {
  fontSize: "1.25rem",
  marginLeft: "10px",
  whiteSpace: "break-spaces"
};

const body = {
  fontSize: "1.75rem",
  padding: "2vw",
  paddingTop: "2vh"
};

function brandDisplay(part) {

  return (
    <Typography variant="h2" sx={brand}>
      Brand: {part['Brand']}
    </Typography>
  );
}

function priceDisplay(part) {
  if (part['Price']) {
    const price = part['Price'].replace(/\s|\$/g, "");
    return (
      <Typography gutterBottom sx={priceCss} >
        ${price}
      </Typography>
    )
  }
}

function imageDisplay(part) {

  if (part['images']) {
    if (part['images'][0]) {
      if (!part['images'][0].startsWith('data:image/gif;')) {
        if (part['images'].length > 0) {
          if (typeof (part['images']) == "string") {
            part['images'] = [part['images']]
            if (!String(part['images']).startsWith("data:image")) {
              part['images'] = [part['images']]
            } else {
              return null // Some of our data has 1 pixel binary images, don't try to display these
            }
          }

          // ToDO: Conditionally import the Carousel only if more than 1 image
          // Only use the Carousel if there is more than 1 image to display
          if (part['images'].length > 1) {
            return (
              <Carousel sx={{ paddingBottom: "5vh" }} interval="14000" duration="1500" animation="slide">
                {part['images'].map((image) => (
                  <Container disableGutters sx={{ display: 'flex', position: "relative", height: "40vh", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                    <img
                      key={image}
                      style={{ objectFit: "scale-down", height: "auto", maxWidth: "100%", maxHeight: "100%" }}
                      alt={part['Name']}
                      src={image}
                    />
                  </Container>
                ))}
              </Carousel>
            )
          } else {
            return (
              <Container disableGutters sx={{ paddingRight: "1vw", display: 'flex', position: "relative", height: "40vh", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                <img
                  style={{ objectFit: "scale-down", height: "auto", maxWidth: "100%", maxHeight: "100%" }}
                  alt={part['Name']}
                  src={part['images'][0]}
                />
              </Container>
            )
          }

        }
      }
    }
  }
}

function descriptionDisplay(part) {

  if (part['Description'] || part['UniqueWrittenCopy']) {
    const description = part['UniqueWrittenCopy'] ? part['UniqueWrittenCopy'] : part['Description']
    return (
      <>
        <Typography sx={{ marginTop: "20px", marginBottom: "10px", fontSize: "1.75rem" }} variant="h2">
          Description
        </Typography>
        <Typography sx={scrappedTextBody} variant="body1">
          {description.trimStart()}
        </Typography>
        <hr />
      </>
    );
  }
}

function bulletedList(part) {
  let rawListData
  if (part['KeyFeatures']) {
    rawListData = part['KeyFeatures']

    let itemList = rawListData.split('\n')
    itemList = itemList.filter(item => item !== "");

    return (
      <>
        <Typography sx={{ marginTop: "20px", fontSize: "1.75rem" }} variant="h2">
          Features
        </Typography>
        {
          itemList.map((item, index) => {
            return <Typography key={index} sx={{ fontSize: "1.1rem" }} >&emsp;• {item}</Typography>;
          })}
      </>
    )

  }
}

function formatText(text) {
  // const urlRegex = /(https?:\/\/[^\s]+)/g;
  const urlRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;

  if (typeof text !== 'string') {
    return text.toString();
  }

  const matches = text.match(urlRegex);

  if (matches) {
    return text.split(urlRegex).map((part, index) => {
      if (matches.indexOf(part) !== -1) {
        return <a key={index} href={part} target="_blank" rel="noopener noreferrer">{part}</a>;
      }

      return part;
    });
  }

  return text;
}

function MatchingCarsDisplay(part) {

  function CarsDisplay() {
    return part.MatchingCars.map((car) => {
      const make = car.Make
      const model = car.Model
      const trim = car.Trim
      const year = car.Year

      return (
        <Link style={{ textDecoration: "none", color: "unset" }} href={"/search/" + make + "/" + model} passHref prefetch={false}>
          <Button sx={{ margin: "10px" }} variant="outlined" target="_blank" color="info" >
            <Typography key={car}>
              {year} {make} {model} {trim}
            </Typography>
          </Button>
        </Link>
      );
    });
  }

  if (!(part.MatchingCars === undefined)) {
    return (
      <>
        <hr style={{ marginTop: "20px" }} />
        <Typography sx={{ fontSize: "1.75rem" }} variant="h2">
          Cars this Part fits
        </Typography>
        <CarsDisplay />
      </>
    );
  }
}

function partDataDisplay(part) {

  const partDetailsKeys = Object.keys(part)
  const URL_REGEX = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
  return partDetailsKeys.map((dataKey) => {
    if (!(dataKey === "Brand" || dataKey === "TechnicalData" || dataKey === "TechnicalDataMeasuredWith" || dataKey === "KeyFeatures" || dataKey === "variants" || dataKey === "UniqueWrittenCopy" || dataKey === "MatchingCars" || dataKey === "lastUpdated" || dataKey === "matchingCars" || dataKey === "price2" || dataKey === "ID" || dataKey == "productLink" || dataKey == "Price" || dataKey == "Name" || dataKey == "Rating" || dataKey == "partNamebackup" || dataKey == "SubmissionTimestamp" || dataKey == "FittingGuide" || dataKey == "Scraped" || dataKey == "Description" || dataKey == "images" || dataKey == "SubmitterEmail")) {
      if (part[dataKey]) {
        if (part[dataKey] != "Unknown") {
          return (
            <>
              <Typography key={part[dataKey]} sx={scrappedTextTitle} display="inline">
                {dataKey}:
              </Typography>
              <Typography sx={scrappedTextBody} display="inline">
                {formatText(part[dataKey])}
              </Typography>
              <br />
            </>
          );
        }
      }
    }
  });
}

function partHeaderDisplay(part, link) {

  let displayImage = false

  if (part['images']) {
    if (part['images'][0]) {
      if (!part['images'][0].startsWith('data:image/gif;')) {
        if (part['images'].length > 0) {
          displayImage = true
        }
      }
    }
  }

  if (displayImage) {
    return (
      <>
        <Grid container>
          <Grid item xs={12} md={6}>
            {imageDisplay(part)}
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography id="keep-mounted-modal-title" variant="h1" sx={title}>
              {part.Name}
            </Typography>
            {brandDisplay(part)}
            {priceDisplay(part)}
            {visitTheManufacturerButton(link)}
          </Grid>
        </Grid>
        <hr />
      </>
    )
  } else {
    return (
      <>
        <Typography id="keep-mounted-modal-title" variant="h1" sx={title}>
          {part.Name}
        </Typography>
        {brandDisplay(part)}
        {priceDisplay(part)}
        {visitTheManufacturerButton(link)}
      </>
    )
  }
}

function fittingGuideDisplay(part) {
  if (part['FittingGuide']) {
    return (
      <>
        <Typography sx={{ marginTop: "20px", fontSize: "1.75rem" }} variant="h2">
          Fitting Guide
        </Typography>
        <Typography sx={{ marginTop: "20px", fontSize: "1.25rem", whiteSpace: "break-spaces" }} variant="body1">
          {part['FittingGuide']}
        </Typography>
        <hr />
      </>
    );
  }
}

function visitTheManufacturerButton(link) {
  return (
    <Box sx={{ paddingTop: "5vh" }}>
      {link &&
        <Link style={{ textDecoration: "none", color: "unset" }} href={link} passHref prefetch={false}>
          <Button sx={{ marginBottom: "5px", minHeight: "4vh", width: "60%", backgroundColor: "#0b5ed7", borderRadius: "8px" }} variant="contained" target="_blank" color="primary" >
            <Typography sx={{ fontSize: "calc(.5em + 0.8vw)", lineHeight: "110%", fontWeight: "bold", color: "#ffffff" }} variant="overline">Visit the Manufacturer</Typography>
          </Button>
        </Link>
      }
    </Box>
  )
}

function partVariantsDisplay(part) {
  // console.log(part)

  if (part['variants']) {
    function listVariantLinks() {
      return part.variants.map((variant) => {
        return (
          <>
            <Link style={{ textDecoration: "none", color: "unset" }} href={variant['productLink']} passHref prefetch={false}>
              <Button sx={{ margin: "10px" }} variant="outlined" target="_blank" color="info" >
                <Typography key={variant['MakeModelYear']}>
                  {variant['MakeModelYear']} {variant['EC']}
                </Typography>
              </Button>
              <br/>
            </Link>
          </>
        )
      })
    }

    return (
      <>
        <Typography sx={{ marginTop: "20px", fontSize: "1.75rem" }} variant="h2">
          Fitting Guide
        </Typography>
        <Typography sx={{ marginTop: "20px", fontSize: "1.25rem" }} variant="h2">
          Click these part variants to see more details on the manufacturers site
        </Typography>
        {listVariantLinks()}
        <hr/>
      </>
    )

  }
}

const PartDisplay = (props) => {

  return (
    <Card sx={body} align="left">
      {partHeaderDisplay(props.part, props.link)}
      {descriptionDisplay(props.part)}
      {fittingGuideDisplay(props.part)}
      {partVariantsDisplay(props.part)}
      <Typography sx={{ marginTop: "20px", marginBottom: "10px", fontSize: "1.75rem" }} variant="h2">
        Part Details
      </Typography>
      {partDataDisplay(props.part)}
      {bulletedList(props.part)}
      {MatchingCarsDisplay(props.part)}
      {visitTheManufacturerButton(props.link)}
    </Card>
  );
};

export default PartDisplay;